export default __webpack_public_path__ + "static/media/Portfolio3.4259beb6.png";